/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import { useGLTF } from '@react-three/drei'
import type { ObjectMap } from '@react-three/fiber'
import type { JSX } from 'react'
import type { Mesh, MeshStandardMaterial } from 'three'
import type { GLTF } from 'three-stdlib'

type GLTFResult = GLTF &
  ObjectMap & {
    nodes: {
      Guitar_1: Mesh
      Guitar_2: Mesh
      Guitar_3: Mesh
      Guitar_4: Mesh
      Guitar_5: Mesh
    }
    materials: {
      Material: MeshStandardMaterial
      Gray: MeshStandardMaterial
      Main: MeshStandardMaterial
      Main2: MeshStandardMaterial
      BLACK: MeshStandardMaterial
    }
  }

export function Guitar(props: JSX.IntrinsicElements['group']) {
  const { nodes, materials } = useGLTF('/models/guitar.glb') as GLTFResult

  return (
    <group {...props} dispose={null}>
      <group position={[0, 0.55, 0.174]} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Guitar_1.geometry}
          material={materials.Material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Guitar_2.geometry}
          material={materials.Gray}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Guitar_3.geometry}
          material={materials.Main}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Guitar_4.geometry}
          material={materials.Main2}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Guitar_5.geometry}
          material={materials.BLACK}
        />
      </group>
    </group>
  )
}

useGLTF.preload('/models/guitar.glb')
